export function setCutGrabX(ref) {
  if (!ref?.current) return;

  const slider = ref.current.querySelector('.aaco-cuts-illustrations__grid');
  let isDown = false;
  let startX;
  let scrollLeft;

  slider.addEventListener('mousedown', (e) => {
    isDown = true;
    slider.classList.add('active');
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
  });
  slider.addEventListener('mouseleave', () => {
    isDown = false;
    slider.classList.remove('active');
  });
  slider.addEventListener('mouseup', () => {
    isDown = false;
    slider.classList.remove('active');
  });
  slider.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - slider.offsetLeft;
    const walk = (x - startX) * 0.7; //scroll-slow
    slider.scrollLeft = scrollLeft - walk;
  });
}

export function resetPositionX(ref) {
  if (!ref?.current) return;
  const slider = ref.current.querySelector('.aaco-cuts-illustrations__grid');
  slider.scrollLeft = 0;
}
